/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 明細データアップロード完了リクエスト
 * @export
 * @interface CompleteOperationDetailUploadRequest
 */
export interface CompleteOperationDetailUploadRequest {
    /**
     * uploadOperationDetailZipで払い出されたoperation_upload_id
     * @type {string}
     * @memberof CompleteOperationDetailUploadRequest
     */
    operationUploadId: string;
}

/**
 * Check if a given object implements the CompleteOperationDetailUploadRequest interface.
 */
export function instanceOfCompleteOperationDetailUploadRequest(value: object): value is CompleteOperationDetailUploadRequest {
    if (!('operationUploadId' in value) || value['operationUploadId'] === undefined) return false;
    return true;
}

export function CompleteOperationDetailUploadRequestFromJSON(json: any): CompleteOperationDetailUploadRequest {
    return CompleteOperationDetailUploadRequestFromJSONTyped(json, false);
}

export function CompleteOperationDetailUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteOperationDetailUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operationUploadId': json['operation_upload_id'],
    };
}

export function CompleteOperationDetailUploadRequestToJSON(json: any): CompleteOperationDetailUploadRequest {
    return CompleteOperationDetailUploadRequestToJSONTyped(json, false);
}

export function CompleteOperationDetailUploadRequestToJSONTyped(value?: CompleteOperationDetailUploadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_upload_id': value['operationUploadId'],
    };
}

